import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  autoReadFront: boolean;
  autoReadBack: boolean;
  frontLang: string;
  backLang: string;
  speechRate: number;
  speechPitch: number;
  speechVolume: number;
  
  // Actions
  setAutoReadFront: (enabled: boolean) => void;
  setAutoReadBack: (enabled: boolean) => void;
  setFrontLang: (lang: string) => void;
  setBackLang: (lang: string) => void;
  setSpeechRate: (rate: number) => void;
  setSpeechPitch: (pitch: number) => void;
  setSpeechVolume: (volume: number) => void;
  
  // Helpers
  shouldAutoRead: (side: 'front' | 'back') => boolean;
}


export const useSettingsStore = create<SettingsState>()(
  persist(
    (set, get) => ({
      autoReadFront: true,
      autoReadBack: true,
      frontLang: 'en-US',
      backLang: 'vi-VN',
      speechRate: 1.0,
      speechPitch: 1.0,
      speechVolume: 1.0,

      setAutoReadFront: (enabled) => set({ autoReadFront: enabled }),
      setAutoReadBack: (enabled) => set({ autoReadBack: enabled }),
      setFrontLang: (lang) => set({ frontLang: lang }),
      setBackLang: (lang) => set({ backLang: lang }),
      setSpeechRate: (rate) => set({ speechRate: rate }),
      setSpeechPitch: (pitch) => set({ speechPitch: pitch }),
      setSpeechVolume: (volume) => set({ speechVolume: volume }),

      shouldAutoRead: (side) => {
        if (side === 'front') return get().autoReadFront;
        if (side === 'back') return get().autoReadBack;
        return false;
      },
    }),

    {
      name: 'flashcard-settings',
    }
  )
);
